// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"cc2c725f","977":"541b29f5"}[chunkId] + ".chunk.js";
};